import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { Switch, Typography, TextField } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import VendorPOController from "Controller/VendorPOController";
import { useState, useEffect } from "react";

const VendorPO = () => {
  const {
    columns,
    expand,
    toggleExpand,
    paginationModel,
    setPaginationModel,
    rowCount,
    poNumber,
    toDate,
    fromDate,
    setPONumber,
    setToDate,
    setFromDate,
    rows,
  } = VendorPOController();

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={3} pb={2} px={2}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="error"
                borderRadius="lg"
                coloredShadow="info"
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <MDTypography variant="h6" color="white">
                  Vendor PO
                </MDTypography>

                <MDBox display="flex" alignItems="center" gap={1}>
                  <Switch checked={expand} size="small" onChange={toggleExpand} />
                  <Typography
                    variant="caption"
                    fontWeight="bold"
                    sx={{ cursor: "pointer", color: "#fff !important" }} // force white
                    onClick={toggleExpand}
                  >
                    Expand
                  </Typography>
                </MDBox>
              </MDBox>

              {/* Filters */}
              <MDBox
                display="flex"
                justifyContent="center"
                gap={2}
                alignItems="center"
                px={2}
                pt={2}
              >
                <TextField
                  label="PO Number"
                  size="medium" // bigger size
                  sx={{ minWidth: 180 }}
                  value={poNumber}
                  onChange={(e) => setPONumber(e.target.value)}
                />
                <TextField
                  label="PO Date From"
                  type="date"
                  size="medium"
                  InputLabelProps={{ shrink: true }}
                  sx={{ minWidth: 150 }}
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
                <TextField
                  label="PO Date To"
                  type="date"
                  size="medium"
                  InputLabelProps={{ shrink: true }}
                  sx={{ minWidth: 150 }}
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                />
                <MDButton
                  color={"error"}
                  onClick={() => {
                    setPONumber("");
                    setFromDate("");
                    setToDate("");
                    localStorage.removeItem("poNumber");
                    localStorage.removeItem("fromDate");
                    localStorage.removeItem("toDate");
                  }}
                >
                  Reset
                </MDButton>
              </MDBox>

              <MDBox pt={3} pb={2} px={2} sx={{ height: "50%", width: "100%" }}>
                {rows.length > 0 ? (
                  <DataGrid
                    rows={rows}
                    columns={columns}
                    disableSelectionOnClick
                    pagination
                    paginationMode="server"
                    // sortingMode="server"
                    filterMode="server"
                    rowCount={rowCount}
                    page={paginationModel.page} // current page
                    pageSize={paginationModel.pageSize} // current page size
                    onPageChange={(newPage) => {
                      setPaginationModel({ ...paginationModel, page: newPage });
                    }}
                    onPageSizeChange={(newPageSize) => {
                      setPaginationModel({ ...paginationModel, pageSize: newPageSize, page: 0 });
                    }}
                    autoHeight
                    componentsProps={{
                      pagination: {
                        labelRowsPerPage: "", // hide label text
                        rowsPerPageOptions: [], // hide dropdown
                      },
                    }}
                    sx={{
                      flex: 1,
                      "& .MuiDataGrid-columnHeaders": {
                        fontWeight: "bold",
                        textAlign: "center",
                      },
                      "& .MuiDataGrid-cell": {
                        borderBottom: "1px solid #f0f0f0",
                        textAlign: "center",
                      },
                    }}
                    sortingOrder={["asc", "desc"]} // only two modes
                    initialState={{
                      sorting: {
                        sortModel: [{ field: "po_date", sort: "desc" }],
                      },
                    }}
                  />
                ) : (
                  <MDBox display="flex" justifyContent="center" alignItems="center" height={300}>
                    <MDTypography variant="caption" fontWeight="bold" sx={{ fontSize: "1rem" }}>
                      No data available!
                    </MDTypography>
                  </MDBox>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default VendorPO;
